<template>
	<el-drawer title="物流信息" :visible.sync="visible" @close='comStateClose' size="600px" :close-on-press-escape="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerCom">
					<el-timeline :reverse="true">
						<el-timeline-item v-for="(item, index) in tableData" :key="index"
							:timestamp="$public.FTime(item.time,'YYYY-MM-DD HH:mm:ss')">
							{{item.desc}}
						</el-timeline-item>
					</el-timeline>
				</div>
				
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			orderNo: {
				default: '',
				
			}
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
		data() {
			return {
				visible: true,
				tableData:[],
			}
		},
		mounted() {
			console.log(this.orderNo)
			this.getTableData()
		},
		methods: {
			//获取物流信息
			getTableData(){
				let params = {
					orderNo:this.orderNo
				}
				this.$http.get(process.env.VUE_APP_AppAdmin + '/api/Logistics/express/info', params).then((res) => {
					if (res.code == 0) {
						console.log(res.data)
						this.tableData = res.data.logisticsTraceDetails;
					}
				})
			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {
					type: 'close'
				});
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;

		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;

			.drawerCom {
				margin-top: 32px;
				padding: 20px;
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
